import { useSelector } from "react-redux";
// Individual MUI imports for better tree shaking
import { default as Snackbar_ } from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography";
import AlertTitle from "@mui/material/AlertTitle";

import { useAppDispatch } from "../../hooks";
import { toggle } from "../../redux/slices/snackbar";

export function Snackbar() {
  const snackbar = useSelector((state: any) => state.snackbar);
  const dispatch = useAppDispatch();
  return (
    <Snackbar_
      open={snackbar.isShown}
      autoHideDuration={4000}
      transitionDuration={500}
      TransitionComponent={Slide}
      onClose={() => {
        dispatch(toggle());
      }}
    >
      <Alert
        onClose={() => {
          dispatch(toggle());
        }}
        severity={snackbar.type}
        sx={{ width: "100%" }}
      >
        <AlertTitle>{snackbar.title}</AlertTitle>
        {snackbar.content}
      </Alert>
    </Snackbar_>
  );
}
